export const PAGE_PARAMS_DEFAULT_PAGE_SIZE = 12 as const;